<template>
	<section class="pb-16">
		<Title>{{ $t("seo.pages.contact-us.title") }}</Title>
		<Meta name="description" :content="$t('seo.pages.contact-us.description')" />
		<Link rel="canonical" :href="`https://${globalConfig.host}${$route.fullPath}`" />
		<Link v-if="globalConfig.isBlue" rel="icon" type="image/x-icon" href="/blue-favicon.ico?v3" />
		<Link v-else rel="icon" type="image/x-icon" href="/favicon.ico?v3" />
		<Meta property="og:url" :content="`https://${globalConfig.host}${$route.fullPath}`" />
		<Meta property="og:type" content="website" />
		<Meta
			property="og:locale"
			:content="`${$i18n.locale}_${$i18n.locale == 'en' ? 'US' : $i18n.locale.toUpperCase()}`"
		/>
		<Meta property="og:title" :content="$t('seo.pages.contact-us.title')" />
		<Meta property="og:description" :content="$t('seo.pages.contact-us.description')" />
		<Meta
			property="og:image"
			content="https://res.cloudinary.com/djbs/image/upload/v1669288084/content/DreamJobs/Graphics/ogimage_dreamjobs.png"
		/>
		<Meta property="og:image:type" content="image/jpeg" />
		<Meta property="og:image:width" content="1200" />
		<Meta property="og:image:height" content="628" />

		<div class="w-full bg-dj-blue-light text-center py-6 mb-6">
			<h1 class="text-5xl font-medium mb-2">{{ $t("contacts.title") }}</h1>
			<h2 class="text-2xl">{{ $t("contacts.subtitle") }}</h2>
		</div>
		<ContactUsHu v-if="region == 'HU'" />
		<ContactUsRo v-else />
	</section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

export default defineComponent({
	name: "ContactUsPage",
	setup() {
		const region = ref("HU");

		onMounted(() => {
			region.value = useRegion.getCurrentRegion().code;
		});

		return {
			region,
		};
	},
});
</script>
